var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTeam = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.75c1.63 0 3.07.39 4.24.9 1.08.48 1.76 1.56 1.76 2.73V11c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1v-.61c0-1.18.68-2.26 1.76-2.73 1.17-.52 2.61-.91 4.24-.91zM4 7c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm1.13 1.1C4.76 8.04 4.39 8 4 8c-.99 0-1.93.21-2.78.58A2.01 2.01 0 000 10.43V11c0 .55.45 1 1 1h3.5v-1.61c0-.83.23-1.61.63-2.29zM20 7c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm4 3.43c0-.81-.48-1.53-1.22-1.85A6.95 6.95 0 0020 8c-.39 0-.76.04-1.13.1.4.68.63 1.46.63 2.29V12H23c.55 0 1-.45 1-1v-.57zM12 0c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3z",
    fill: "#667085"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTeam);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/team.0bf942ca8b986c7046718b71ebade065.svg";